module.exports = __webpack_public_path__ + "img/zk-icon-operation-plan.040655d9.svg";